import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import axios from 'axios';
import decode from 'jwt-decode';
import {GET_USER_AUTH} from '../constants/URLS';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("user", null);
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (data) => {
	let serverLogin = await axios({
		method: 'post',
		url: GET_USER_AUTH,
		data:{
			u: data.username,
			p: data.password
		}
	})
	
	if (!serverLogin.data.success) {
		setUser(null);
		return false
	}

	axios.defaults.headers.common['Authorization'] = serverLogin.data.token;
	const decoded = decode(serverLogin.data.token);
	const arrSections = decoded.sections.split(',')
	const objSections = arrSections.reduce((acc,cur) => {acc[cur] = true; return acc},{})
	
	setUser({
		token: serverLogin.data.token,
		sections: objSections
	});

	// Based on who logs in, what should the first page be?
	let firstPage = '/dashboard'
	if (objSections['addesso']) {
		firstPage = '/dashboard'
	} else {
		switch(arrSections[0]) {
			case 'anhi': 
				firstPage = '/anhi-programs'
				break;
			case 'testing': 
				firstPage = '/test-one'
				break;
			default: 
				firstPage = '/dashboard'
		}
	}

    navigate(firstPage);
	return true
  };

  // call this function to sign out logged in user
  const logout = () => {
    setUser(null);
    navigate("/login", { replace: true });
  };

  const loggedIn = () => {
	if (user) {
		axios.defaults.headers.common['Authorization'] = user.token;
		return !!user.token && !isTokenExpired(user.token)
  	}
	return false
  }

  const  isTokenExpired = (token) => {
	try {
		const decoded = decode(token);
		if (decoded.exp < Date.now() / 1000) { // Checking if token is expired.
			return true;
		}
		else
			return false;
	}
	catch (err) {
		return false;
	}
}

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
	  loggedIn
    }),
    [user]
  );

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
	let tokenInfo = useContext(AuthContext)
	//debugger
	return tokenInfo;
};